import { Helmet } from "react-helmet";
import { useLocation } from "react-router-dom";
import { useRef } from "react";
import Logo from "../../../asset/images/logo.png";
import { useReactToPrint } from "react-to-print";
import { useSelector } from "react-redux";
import ShareInvoiceHeader from "component/ShareHeader";
import getInitials from "utilities/getInitials";

const ShareInvoice = () => {
    const { state } = useLocation();
    const imageRef = useRef(null);
    const users = useSelector((state) => state?.users);
    const business = useSelector((state) => state?.business);
    const reactToPrintFn = useReactToPrint({ contentRef: imageRef });

    return (
        <div className="h-100 w-100">
            <div
                className=""
                style={{
                    maxWidth: "2000px",
                    width: "100%",
                    margin: "0px auto",
                }}
            >
                <Helmet>
                    <title>Invoice</title>
                </Helmet>
                <ShareInvoiceHeader
                    header={"Share Invoice"}
                    isbtn={true}
                    downloadinvoice={reactToPrintFn}
                />
                <div className="shareClass">
                    {/* The new receipt design */}
                    <div className="w-full max-w-xl pb-5 mx-auto bg-white" ref={imageRef}>
                        <div
                            className="flex items-center justify-between px-3 py-6"
                            style={{ borderBottom: "5px solid #6F00FF" }}
                        >
                            <img src={Logo} alt="Logo" className="size-12" />

                            <p className="text-3xl font-medium">
                                Invoice
                                <span className="ml-2 text-xl font-normal capitalize">
                                    #{state.invoiceID}
                                </span>
                            </p>
                        </div>

                        <div className="px-4 mt-5">
                            <div>
                                <div className="flex items-start justify-between">
                                    <div className="flex items-center gap-2">
                                        <div className="flex items-center justify-center w-12 h-12 bg-purple-100 rounded-full">
                                            <span className="text-2xl font-medium text-purple-600 capitalize">
                                                {getInitials(business?.name, 2)}
                                            </span>
                                        </div>
                                        <div className="">
                                            <h1 className="mb-0 text-base font-medium text-gray-900">
                                                {business?.name}
                                            </h1>
                                            <p className="text-sm text-gray-600">
                                                {" "}
                                                {users?.firstName} {users?.lastName}
                                            </p>
                                        </div>
                                    </div>
                                    <div className="text-right">
                                        <h5 className="mb-0 font-medium text-gray-900">To</h5>
                                        <div className="space-y-1">
                                            <p className="font-medium text-gray-900">
                                                {" "}
                                                {state?.firstName} {state?.lastName}
                                            </p>
                                            <p className="text-gray-500">{state?.businessName}</p>
                                            <p className="text-gray-500">
                                                {state?.businessAddress}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                                <div className="mt-3 text-sm">
                                    <p className="text-gray-500">
                                        Issued: {new Date(state.issueDate).toDateString()}
                                    </p>
                                    <p className="text-gray-500">
                                        Due: {new Date(state.dueDate).toDateString()}
                                    </p>
                                </div>
                            </div>
                            <div className="my-10">
                                <table className="w-full">
                                    <thead>
                                        <tr>
                                            <th className="pb-4 font-normal text-left text-gray-500">
                                                Items
                                            </th>
                                            <th className="pb-4 font-normal text-right text-gray-500">
                                                Quantity
                                            </th>
                                            <th className="pb-4 font-normal text-right text-gray-500">
                                                Unit Price
                                            </th>
                                            <th className="pb-4 font-normal text-right text-gray-500">
                                                Total
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody className="border-gray-200 border-y">
                                        {state?.invoiceItems?.map((item, index) => {
                                            return (
                                                <tr key={index}>
                                                    <td className="py-4 text-gray-900">
                                                        {item.itemName}
                                                    </td>
                                                    <td className="py-4 text-right text-gray-900">
                                                        {item.quantity}
                                                    </td>
                                                    <td className="py-4 text-right text-gray-900">
                                                        {state.currency === "NGN"
                                                            ? "₦"
                                                            : state.currency === "GBP"
                                                            ? "£"
                                                            : "€"}
                                                        {parseFloat(
                                                            item.pricePerUnit
                                                        ).toLocaleString()}
                                                    </td>
                                                    <td className="py-4 text-right text-gray-900">
                                                        {state.currency === "NGN"
                                                            ? "₦"
                                                            : state.currency === "GBP"
                                                            ? "£"
                                                            : "€"}{" "}
                                                        {parseFloat(
                                                            item.quantity * item.pricePerUnit
                                                        ).toLocaleString()}
                                                    </td>
                                                </tr>
                                            );
                                        })}
                                    </tbody>
                                    <tfoot>
                                        <tr>
                                            <td
                                                colSpan={3}
                                                className="pt-4 text-right text-gray-500"
                                            >
                                                Subtotal
                                            </td>
                                            <td className="pt-4 text-right text-gray-900">
                                                {" "}
                                                {state.currency === "NGN"
                                                    ? "₦"
                                                    : state.currency === "GBP"
                                                    ? "£"
                                                    : "€"}
                                                {parseFloat(state.totalAmount).toLocaleString()}{" "}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td
                                                colSpan={3}
                                                className="pt-4 text-right text-gray-500"
                                            >
                                                VAT (3%)
                                            </td>
                                            <td className="pt-4 text-right text-gray-900">
                                                {state.currency === "NGN"
                                                    ? "₦"
                                                    : state.currency === "GBP"
                                                    ? "£"
                                                    : "€"}
                                                25 000
                                            </td>
                                        </tr>
                                        <tr>
                                            <td
                                                colSpan={3}
                                                className="pt-4 text-right text-gray-500"
                                            >
                                                Paid
                                            </td>
                                            <td className="pt-4 text-right text-gray-900">
                                                {state.currency === "NGN"
                                                    ? "₦"
                                                    : state.currency === "GBP"
                                                    ? "£"
                                                    : "€"}
                                                {parseFloat(
                                                    state.totalAmount + state.totalAmount * 0.3
                                                ).toLocaleString()}{" "}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td
                                                colSpan={3}
                                                className="pt-4 text-right text-gray-500"
                                            >
                                                Amount due
                                            </td>
                                            <td className="pt-4 font-medium text-right text-gray-900">
                                                {state.currency === "NGN"
                                                    ? "₦"
                                                    : state.currency === "GBP"
                                                    ? "£"
                                                    : "€"}
                                                {parseFloat(
                                                    state.totalAmount + state.totalAmount * 0.3
                                                ).toLocaleString()}{" "}
                                            </td>
                                        </tr>
                                    </tfoot>
                                </table>
                            </div>

                            <div className="">
                                {/* <h2 className="text-sm font-normal text-gray-500">
                                    Complete payment for this invoice using any of the options
                                    below.
                                </h2>

                                <div className="mt-4">
                                    <h3 className="text-base text-gray-600">Payment link</h3>
                                    <div className="flex items-center justify-between px-4 py-3 bg-secondary-10 rounded-xl">
                                        <span className="text-[#6F00FF]">
                                            https://tradevu.io/pivo
                                        </span>
                                        <button
                                            style={{ background: "#6F00FF" }}
                                            className="px-6 py-2 text-white transition-colors rounded-md hover:bg-purple-700"
                                        >
                                            Pay Invoice
                                        </button>
                                    </div>
                                </div> */}

                                {/* Bank Transfer Section */}
                                {/* <div className="mt-4 mb-8">
                                    <h3 className="text-lg !text-left">Bank transfer</h3>
                                    <div className="grid grid-cols-3 gap-8 p-2 border rounded-md">
                                        <div className="">
                                            <p className="text-sm text-gray-400">Account name</p>
                                            <p className="text-base font-medium text-gray-800">
                                                Nikru Emina
                                            </p>
                                        </div>
                                        <div className="">
                                            <p className="text-sm text-gray-400">Bank name</p>
                                            <p className="text-base font-medium text-gray-800">
                                                Access Bank
                                            </p>
                                        </div>
                                        <div className="">
                                            <p className="text-sm text-gray-400">Account Number</p>
                                            <p className="text-base font-medium text-gray-800">
                                                0065749302
                                            </p>
                                        </div>
                                    </div>
                                </div> */}

                                <div className="mt-3 space-y-4">
                                    <h2 className="text-xl text-[#6F00FF] font-light">
                                        Thank you!
                                    </h2>
                                    <p className="space-x-1 text-xs font-light text-gray-500">
                                        <span>
                                            If you have questions for us, please call a
                                            representative on
                                        </span>
                                        <a
                                            href="tel:+2347073183321"
                                            className="!text-[#6F00FF]  hover:underline"
                                        >
                                            +2347073183321
                                        </a>{" "}
                                        or
                                        <a
                                            href="tel:+447903175084"
                                            className="!text-[#6F00FF]  hover:underline"
                                        >
                                            +447903175084
                                        </a>
                                        <span>
                                            You can also send us an email at{" "}
                                            <a
                                                href="mailto:hello@tradevu.co"
                                                className="!text-[#6F00FF]  hover:underline"
                                            >
                                                hello@tradevu.co
                                            </a>
                                            .
                                        </span>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ShareInvoice;
